// API Configuration
const config = {
  // Development
  development: {
    apiBaseUrl: 'http://localhost:5000'
  },
  // Production (Railway)
  production: {
    apiBaseUrl: 'https://ciagent-test.up.railway.app'
  }
};

// Get current environment
const environment = process.env.NODE_ENV || 'development';

// Allow environment variable override for production builds
const resolvedApiBaseUrl =
  process.env.REACT_APP_API_BASE_URL || config[environment].apiBaseUrl;

// Export the appropriate config
export const API_BASE_URL = resolvedApiBaseUrl;

// For backward compatibility
export default {
  ...config[environment],
  apiBaseUrl: resolvedApiBaseUrl
};
